<template>
  <div class="l-container">
    <div class="c-box mb-8">
      <MenuDetailHeader v-model="headerData" />
      <MenuNavigation />
      <div class="mt-5">
         <div class="list-link">
            <div class="item-link" v-for="(category,index) in galleryData" :key="`link-move-${index}`">
              <div class="item-link__inner" v-if="category.imageCategoryNm && category.images.length">
                <a class="link-content" :href="`#${index}`" v-smooth-scroll="{ offset: -10, duration: 400 }" >{{category.imageCategoryNm}}({{category.images.length}}) </a>
              </div>
            </div>
        </div>
      </div>
      
      <div v-if="galleryData.length > 0" class="photo-list-container">
        <div v-for="(category, index) in galleryData" :key="index">
          <div>
            <SectionContentTitle :id="index"  lineType="v-line" :titleContent="`${category.imageCategoryNm}(${category.images.length})`"/>
            <div class="list-photo" >
              <div v-for="(item, index) in category.images" :key="`photo-item-${index}`" class="item-photo">
                <img class="item-image" :src="getImgUrl(item)" @click="showPhotoGallery(item, category)">
                <p> {{item.imageExplanation}} </p>
              </div>
            </div>
            <a-divider v-if="index < galleryData.length - 1"/>
          </div>
        </div>
      </div> 
      <div v-else class="pb-5">
        <a-list :data-source="[]" />
      </div> 
      <GalleryViewPopup :visible="showGallery"
                        :numberOfImage="false"
                        v-model="galleryData"
                        :selectedImage="selectedImage"
                        :categoryImage="categoryImage"
                        @ok="showGallery=false; selectedImage = null"
                        @close="showGallery=false; selectedImage = null"/>
      
    </div>
  </div>
</template>

<script>
import { MenuNavigation, SectionContentTitle } from '@/components/compound'
import MenuDetailHeader from './MenuDetailHeader'
import GalleryViewPopup from '../GalleryViewPopup'
import { GET_MENU_DETAIL, GET_PHOTO_GALLERY } from '@/store/modules/menu/actions'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import { SAVE_DATA_BS_APP_02_001 } from '@/store/modules/bs_app/actions'

const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')

import _ from 'lodash'
export default {
  components: {
    SectionContentTitle,
    GalleryViewPopup,
    MenuNavigation,
    MenuDetailHeader
  },
  data() {
    return {
      breadcrumbs: [],
      headerData: null,
      showGallery: false,
      galleryData: [],
      selectedImage: null,
      categoryImage: null,
      dataObject: {},
      dataImgGroupByCtgNm: {},
      dataClone: []
    }
  },
 
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
    this.$store.dispatch(SAVE_DATA_BS_APP_02_001, null)
  },
  mounted() {
    // call API
    this.getMenuDetail()
    this.getPhotoGallery()
  },
  computed: {
    menuInfoState() {
      return _.cloneDeep(this.$store.getters.menuBasicInfo)
    }
  },
  methods: {
    getImgUrl(filename) {
      if(filename && filename.imageUrl) {
        return filename.imageUrl
      }
      return require('@/assets/images/slide-img-placeholder.png')
    },
    getMenuDetail() {
      const { menuNo } = this.$route.query
      this.$store.dispatch(GET_MENU_DETAIL, {menuNo}).then(
        (data) => {
          if(data) {
            this.headerData = { ..._.get(data, 'storeList.facilities[0]', {}), ...data}
            this.breadcrumbs[this.breadcrumbs.length - 1].title = _.get(data, 'menuNm', '')
            this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)
          }
        })
    },
    getPhotoGallery() {
      const { menuNo } = this.$route.query
      this.$store.dispatch(GET_PHOTO_GALLERY, menuNo).then(
        (data) => {
          const imgCategoriesMap = {}
          if (data) {
            const productImages = data
            productImages.forEach(img => {
              if (imgCategoriesMap[img.imageCategoryCd]) {
                imgCategoriesMap[img.imageCategoryCd].images.push({
                  imageUrl: img.imageUrl ? img.imageUrl : PLACEHOLDER_IMG,
                  alt: img.imageExplanation,
                  imageExplanation: img.imageExplanation
                })
              } else {
                imgCategoriesMap[img.imageCategoryCd] = {
                  id: img.imageCategoryCd,
                  imageCategoryCd: img.imageCategoryCd,
                  imageCategoryNm: img.imageCategoryNm,
                  images: [
                    {
                      imageUrl: img.imageUrl ? img.imageUrl : PLACEHOLDER_IMG,
                      alt: img.imageExplanation,
                      imageExplanation: img.imageExplanation
                    }
                  ]
                }
              }
            })
          }
          this.galleryData = Object.keys(imgCategoriesMap).map(e => imgCategoriesMap[e])
        },
        () => {
          this.galleryData = []
        })
    },
  
    showPhotoGallery(item, category) {
      if (this.galleryData.length) {
        this.showGallery = true
        this.selectedImage = item
        this.categoryImage = category
        return
      }
      const { menuNo } = this.$route.query
      this.$store.dispatch(GET_PHOTO_GALLERY, menuNo).then(
        (data) => {
          const imgCategoriesMap = {}
          if (data) {
            const productImages = data
            productImages.forEach(img => {
              if (imgCategoriesMap[img.imageCategoryCd]) {
                imgCategoriesMap[img.imageCategoryCd].images.push({
                  imageUrl: img.imageUrl,
                  alt: img.imageExplanation,
                  imageExplanation: img.imageExplanation
                })
              } else {
                imgCategoriesMap[img.imageCategoryCd] = {
                  id: img.imageCategoryCd,
                  imageCategoryCd: img.imageCategoryCd,
                  imageCategoryNm: img.imageCategoryNm,
                  images: [
                    {
                      imageUrl: img.imageUrl,
                      alt: img.imageExplanation,
                      imageExplanation: img.imageExplanation
                    }
                  ]
                }
              }
            })
          }
          this.galleryData = Object.keys(imgCategoriesMap).map(e => imgCategoriesMap[e])
          this.selectedImage = item
          this.showGallery = true
        },
        () => {
          this.galleryData = []
          this.showGallery = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>